export default "__VITE_ASSET__6eT2QaqL__"